import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '@store/store.ts'
import { hydrateCategoriesFromJSON, hydrateCurrentUser } from '@utils/hydrator.js'
import { setScopedFilter } from '@features/filters/index.js'
import SuspenseFallback from '@components/SuspenseFallback.tsx'
import { RedirectorContainer } from '@features/redirection/index.js'

const DashboardContainer = lazy(() =>
  import('./features/dashboard/index.js').then(module => ({ default: module.DashboardContainer }))
)

window.Timetoast.dashboard = {
  ...window.Timetoast.dashboard,
  index: {
    init: function (options) {
      const uiScope = 'dashboardIndex'

      // hydrate store
      hydrateCurrentUser()
      hydrateCategoriesFromJSON(options.data.raw.categoriesData)

      // set up initial internal access level filter
      store.dispatch(
        setScopedFilter({
          uiScope,
          filterName: 'visibility',
          value: 'account',
        })
      )

      // tab content
      const root = createRoot(document.getElementById(options.target))
      root.render(
        <Provider store={store}>
          <RedirectorContainer />
          <Suspense fallback={<SuspenseFallback />}>
            <DashboardContainer uiScope={uiScope} />
          </Suspense>
        </Provider>
      )
    },
  },
}
